import script from "./alarm-record.vue?vue&type=script&setup=true&lang=js"
export * from "./alarm-record.vue?vue&type=script&setup=true&lang=js"

import "./alarm-record.vue?vue&type=style&index=0&id=5b89299d&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b89299d"]])

export default __exports__